module.exports = __webpack_public_path__ + "f7b0f3e7b452becbe72c957a4e87c585.pdf";